module.exports = __webpack_public_path__ + "videos/whats-new-53-colordrop_16x9_en.56e809b.mp4";